import { render, staticRenderFns } from "./timeInUiByTensionBeatsModal.vue?vue&type=template&id=0924a64e"
import script from "./timeInUiByTensionBeatsModal.vue?vue&type=script&lang=js"
export * from "./timeInUiByTensionBeatsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports